import "./LoginPage.css";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Master from "../../utils/Master";
import axios from "axios";
import { Snackbar, Alert } from "@mui/material";

const LoginPage = () => {
  const { setrefreshToken, settoken } = useContext(Master);
  const navigate = useNavigate();
  const location = useLocation();
  const from = useRef(location?.state?.from?.pathname || "/");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error"); // "success" | "error" | "warning" | "info"

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  useEffect(() => {
    /* global google */

    google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
    });

    google.accounts.id.renderButton(document.getElementById("signInBtn"), {
      theme: "outline",
      size: "large",
    });

    google.accounts.id.prompt();

    async function handleCredentialResponse(response) {
      try {
        const validateResponse = await axios.post(
          process.env.REACT_APP_API_BASE + "node/auth/login",
          {
            jwtcredential: response.credential,
            refreshToken: localStorage.getItem("refreshToken"),
          },
          {
            headers: {
              "Content-type": "application/json",
              // Authorization: "abdjcdifouvn",
            },
            // withCredentials: true,
          }
        );

        // ✅ Success flow
        const token = validateResponse.data.accessToken;
        const refreshToken = validateResponse.data.refreshToken;
        setrefreshToken(refreshToken);
        settoken(token);

        localStorage.setItem("tokenKey", token);
        localStorage.setItem("refreshToken", refreshToken);

        const result = jwtDecode(token);
        if (result) {
          localStorage.setItem(
            "certificaterole",
            result.role === "admin" ? "certificateadmin" : "issuer"
          );
          localStorage.setItem("name", result.name);

          setSnackbarSeverity("success");
          setSnackbarMessage("Login successfull");
          setSnackbarOpen(true);

          setTimeout(
            () => navigate("/issuedcertificates", { replace: true }),
            300
          );
        }
      } catch (error) {
        console.error("Login validation failed:", error);

        if (error.response) {
          if (error.response.status === 404) {
            setSnackbarMessage("User not registered. Please contact admin.");
          } else if (error.response.status === 401) {
            setSnackbarMessage("Invalid Google credentials. Please try again.");
          } else {
            setSnackbarMessage("Server error occurred. Try again later.");
          }
        } else {
          setSnackbarMessage("Login Failed !!");
        }

        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }
  }, [navigate, setrefreshToken, settoken]);

  return (
    <>
      <div className="loginpg"></div>
      <form className="loginForm" style={{ paddingLeft: "50px" }}>
        <div className="image">
          <img
            alt="Gradious"
            className="logo1"
            style={{ width: "200px" }}
            src="https://gradious.com/wp-content/uploads/2021/09/Final-Logo-2.svg"
          />
        </div>
        <div className="tabs">Sign In</div>
        <div className="signInForm">
          <button id="signInBtn">Sign In with Google</button>
        </div>
      </form>

      {/* ✅ Snackbar for feedback */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default LoginPage;
